export enum MenuItemLabels {
  GroupHeadDashboard = 'Group Head Dashboard',
  MyDashboard = 'My Dashboard',
  Clients = 'Clients',
  Matters = 'Matters',
  Timesheets = 'Timesheets',
  Compliance = 'Compliance',
  Billing = 'Billing',
  BillingWip = 'Billing Wip',
  BillingRuns = 'Billing Runs',
  Disbursement = 'Disbursement',
  TimesheetReport = 'Timesheet Report',
  BusinessReporting = 'Business Reporting',
  Users = 'Users',
  Configuration = 'Configuration',
  Roles = 'Roles',
  SystemConfiguration = 'System Configuration',
  Feedback = 'Feedback',
  Logout = 'Logout',
  CompleteNewMatter = 'Complete New Matter',
  Feedbacks = 'Feedbacks',
  HjHours = 'Hjhours',
  TempTimeHour = 'Temptimehour',
  BillableHour = 'BillableHour',
  EditProfile = 'editprofile',
  AiChat = 'AI Chat',
  ClientRates = 'Client Rates',
  financeDashboard = 'Finance Dashboard',
  accruedHours = 'Accrued Hours',
  Extend = 'Extend',
}

export enum ClientMenuItemLabels {
  Instructions = 'Instructions',
  Matters = 'Matters',
  Invoices = 'Invoices',
  Users = 'Users',
  Logout = 'Logout',
  EditProfile = 'Edit-Profile',
}
